import React from 'react';

interface Props {
	subject: string;
	showSubject?: boolean;
	title: string;
	description?: string;
	compact?: boolean;
}

const HeroTitle = ({subject, showSubject = true, title, description, compact = false}: Props) => {
	return (
		<div className="mx-auto max-w-4xl text-center pt-5 sm:pt-10">
			{showSubject && <h1 className="text-base/7 font-semibold text-neutral-900">{subject}</h1>}
			<p
				className={
					compact
						? 'mt-2 text-balance text-3xl font-semibold tracking-tight text-gray-900 sm:text-4xl'
						: 'mt-2 text-balance text-5xl font-semibold tracking-tight text-gray-900 sm:text-6xl'
				}
			>
				{title}
			</p>
			{description &&
				<p
					className={
						compact
							? 'mx-auto mt-3 max-w-4xl text-pretty text-center text-base font-medium text-gray-600 sm:text-lg'
							: 'mx-auto mt-6 max-w-4xl text-pretty text-center text-lg font-medium text-gray-600 sm:text-xl/8'
					}
				>
					{description}
				</p>
			}
		</div>
	);
};

export default HeroTitle;
